import LoadingDots from '@alltrails/denali/components/LoadingDots';
import styles from './Loading.module.scss';

const Loading = () => {
  return <LoadingDots className={styles.loading} />;
};

export default Loading;
